import AchievementCard from '@/components/AchievementCard';
import AchievementModalNotification from '@/components/AchievementModalNotification';
import Constants from '@/Constants';
import { useGet } from '@/hooks/useGet';
import { PersonBadge } from '@/models/PersonBadge';
import { analyticsService, FlowEvents } from '@/services/AnalyticsService';
import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './style.scss';

const AchievementsPage: React.FC = () => {
    const [activeModalNotification, setActiveModalNotification] = useState<boolean>(false);

    const history = useHistory();

    const { strings, personId } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        personId: state.identity.data.person.id || 0,
        achievements: state.achievements.personBadges,
    }));

    const { data: achievements } = useGet<PersonBadge[]>(Constants.CAST_GET_ACHIEVEMENTS_URI.replace('%p', personId.toString()));

    const closeModal = (): void => {
        setActiveModalNotification(false);
    };

    useEffect(() => {
        // Caso usuário mude o idioma, ele redireciona pra home e não quero logar no analytics.
        if (strings._LANGUAGE === Constants.language.PT) {
            analyticsService.logEvent(FlowEvents.MENU_ACHIEVEMENTS);
        } else {
            history.push('/');
        }
    }, [strings._LANGUAGE]);

    return (
        <>
            <AchievementModalNotification visible={activeModalNotification} onHide={closeModal} />
            <div className="achievements">
                <div className="info-container">
                    <div
                        className="info-title"
                        onClick={() => {
                            setActiveModalNotification(true);
                        }}
                    >
                        <span> {strings.ACHIEVEMENTS.DOUBTS}</span>
                        <i className="material-icons-outlined align-top">{Constants.icons.ERROR_OUTLINE}</i>
                    </div>
                </div>
                <div className="achievements-grid">
                    {achievements?.map((personBadge: PersonBadge, index: number) => (
                        <AchievementCard key={index} personBadge={personBadge} />
                    ))}
                </div>
            </div>
        </>
    );
};
export default AchievementsPage;
